import { useState } from "react";

export const useOpen = (initial = false) => {
	const [open, setOpen] = useState(initial);
	const openMethod = () => {
		setOpen(!open);
	};
	return { open, openMethod };
};
